export default __webpack_public_path__ + "static/media/005-whatsapp.5e44c35b.svg";